// extracted by mini-css-extract-plugin
module.exports = {"location":"footer-location_location__SWEHl","heading":"footer-location_heading__JJ_Rq","link":"footer-location_link__GuKJ5"};